import EntityState from '@/modules/common/store/entityState'
import Company from '@/modules/company/domain/company'

export default class CompanyState extends EntityState<Company> {
  managed: Company | null = null
}
